import ConfirmDocs from "./ConfirmDocs";
export default ConfirmDocs